export const CELEBRATION_WHITELIST = [
  'Amazing!', 'Great job!', 'You did it!',
  'Wonderful!', 'Fantastic!', 'Keep it up!',
  'Way to go!', 'Excellent!',
];

/** Valid Turn Color names for phoneme audio playback */
export const PHONEME_COLORS = [
  'black', 'red', 'pink', 'plum', 'green', 'blue', 'aqua', 'wood',
  'yellow', 'lime', 'brown', 'orange', 'purple', 'gray',
] as const;

export type PhonemeColor = (typeof PHONEME_COLORS)[number];

export const SIMILARITY_THRESHOLD = 0.6;
export const GAP_THRESHOLD = 0.15;
export const INACTIVITY_TIMEOUT_MS = 60000;
export const COUNTDOWN_SECONDS = 30;
export const RE_ENROLLMENT_DAYS = 90;
export const SNOOZE_DAYS = 30;
